export default class BaseTabItem {
    
    /**
     * @var {boolean}
     */
    showTabItem = false;


    initTabItem(tabItemID) {        
        window.addEventListener('pegasus-tab-item-selected', (event) => {
            if(!event.detail.tabGroup.includes(tabItemID)) {
                return;
            }
            this.showTabItem = event.detail.targetID === tabItemID;
        });
    }

}

document.addEventListener('alpine:init', () => {
    Alpine.data('TabItem', () => new BaseTabItem());
});